/**
 * FOC feedback-note Met/Not-met checklist from atomic tour step requirements.
 * Leaf relative to focFeedbackNoteBody (must not import it) to avoid cycles with
 * tour step modules that import focTourFeedback.
 */

import {
  FOC_TOUR_LABEL_CMD_IC,
  FOC_TOUR_LABEL_CMD_LEGAL,
  FOC_TOUR_LABEL_CMD_LIAISON,
  FOC_TOUR_LABEL_CMD_PIO,
  FOC_TOUR_LABEL_CMD_SAFETY,
  FOC_TOUR_LABEL_COP_LAYERS,
  FOC_TOUR_LABEL_FSLTP,
  FOC_TOUR_LABEL_HUB_COP,
  FOC_TOUR_LABEL_IAP_FORMS,
  FOC_TOUR_LABEL_IAP_PREP_OPS,
  FOC_TOUR_LABEL_INCIDENT_ROSTER,
  FOC_TOUR_LABEL_INCIDENTS,
  FOC_TOUR_LABEL_INITIAL_RESPONSE,
  FOC_TOUR_LABEL_NOTIFICATIONS,
  FOC_TOUR_LABEL_ORG_WORKSPACE,
  FOC_TOUR_LABEL_PLANNING,
  FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
  FOC_TOUR_LABEL_PLANNING_P_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_MODEL,
  FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
  FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
  FOC_TOUR_LABEL_AI_FOC,
  FOC_TOUR_LABEL_AI_IOC,
  FOC_TOUR_LABEL_DMOB,
  FOC_TOUR_LABEL_EXT,
  FOC_TOUR_LABEL_LOG,
  FOC_TOUR_LABEL_OPS,
  FOC_TOUR_LABEL_PLN_DEMOB,
  FOC_TOUR_LABEL_PLN_DOCS,
  FOC_TOUR_LABEL_PLN_PSC,
  FOC_TOUR_LABEL_PLN_RESOURCE,
  FOC_TOUR_LABEL_PLN_SITL,
  FOC_TOUR_LABEL_RES_211,
  FOC_TOUR_LABEL_RES_213RR,
  FOC_TOUR_LABEL_RES_214,
  FOC_TOUR_LABEL_RES_MODEL,
  FOC_TOUR_LABEL_SITL_COP,
  FOC_TOUR_LABEL_TRANSITION,
  FOC_TOUR_LABEL_WS,
} from 'components/MapPage/focTourLabels';
import {
  FOC_CMD_IC_TOUR_STEPS,
  FOC_CMD_LEGAL_TOUR_STEPS,
  FOC_CMD_LIAISON_TOUR_STEPS,
  FOC_CMD_PIO_TOUR_STEPS,
  FOC_CMD_SAFETY_TOUR_STEPS,
} from 'components/MapPage/focCmdTour/focCmdTourSteps';
import { FOC_COP_LAYERS_TOUR_STEPS } from 'components/MapPage/focCopLayersTour/focCopLayersTourSteps';
import { FOC_FSLTP_TOUR_STEPS } from 'components/MapPage/focFsltpTour/focFsltpTourSteps';
import { FOC_INCIDENT_ROSTER_TOUR_STEPS } from 'components/MapPage/focIncidentRosterTour/focIncidentRosterTourSteps';
import { FOC_INCIDENTS_TOUR_STEPS } from 'components/MapPage/focIncidentsTour/focIncidentsTourSteps';
import { FOC_INITIAL_RESPONSE_TOUR_STEPS } from 'components/MapPage/focInitialResponseTour/focInitialResponseTourSteps';
import { FOC_NOTIFICATIONS_TOUR_STEPS } from 'components/MapPage/focNotificationsTour/focNotificationsTourSteps';
import { FOC_IAP_FORMS_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focIapFormsTourSteps';
import { FOC_IAP_PREP_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focIapPrepTourSteps';
import { FOC_PLANNING_P_COMMAND_STAFF_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPCommandStaffTourSteps';
import { FOC_PLANNING_P_MEETING_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPMeetingTourSteps';
import { FOC_PLANNING_P_MODEL_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPModelTourSteps';
import { FOC_PLANNING_P_PREP_TACTICS_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPPrepTacticsTourSteps';
import { FOC_PLANNING_P_TACTICS_MEETING_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPTacticsMeetingTourSteps';
import { FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPTacticsWorkflowTourSteps';
import { FOC_PLANNING_PREP_TOUR_STEPS } from 'components/MapPage/focPlanningPTour/focPlanningPrepTourSteps';
import { FOC_PLANNING_TOUR_STEPS } from 'components/MapPage/focPlanningTour/focPlanningTourSteps';
import { FOC_AI_FOC_TOUR_STEPS } from 'components/MapPage/focAiTour/focAiFocTourSteps';
import { FOC_AI_IOC_TOUR_STEPS } from 'components/MapPage/focAiTour/focAiIocTourSteps';
import { FOC_DMOB_TOUR_STEPS } from 'components/MapPage/focDmobTour/focDmobTourSteps';
import { FOC_EXT_TOUR_STEPS } from 'components/MapPage/focExtTour/focExtTourSteps';
import { FOC_LOG_TOUR_STEPS } from 'components/MapPage/focLogTour/focLogTourSteps';
import { FOC_OPS_TOUR_STEPS } from 'components/MapPage/focOpsTour/focOpsTourSteps';
import { FOC_PLN_DEMOB_TOUR_STEPS } from 'components/MapPage/focPlnTour/focPlnDemobTourSteps';
import { FOC_PLN_DOCS_TOUR_STEPS } from 'components/MapPage/focPlnTour/focPlnDocsTourSteps';
import { FOC_PLN_PSC_TOUR_STEPS } from 'components/MapPage/focPlnTour/focPlnPscTourSteps';
import { FOC_PLN_RESOURCE_TOUR_STEPS } from 'components/MapPage/focPlnTour/focPlnResourceTourSteps';
import { FOC_PLN_SITL_TOUR_STEPS } from 'components/MapPage/focPlnTour/focPlnSitlTourSteps';
import { FOC_RES_211_TOUR_STEPS } from 'components/MapPage/focResTour/focRes211TourSteps';
import { FOC_RES_213RR_TOUR_STEPS } from 'components/MapPage/focResTour/focRes213rrTourSteps';
import { FOC_RES_214_TOUR_STEPS } from 'components/MapPage/focResTour/focRes214TourSteps';
import { FOC_RES_MODEL_TOUR_STEPS } from 'components/MapPage/focResTour/focResModelTourSteps';
import { FOC_TRANSITION_TOUR_STEPS } from 'components/MapPage/focTransitionTour/focTransitionTourSteps';
import { FOC_WS_TOUR_STEPS } from 'components/MapPage/focWsTour/focWsTourSteps';
import { HUB_COP_TOUR_STEPS } from 'components/MapPage/hubCopTour/hubCopTourSteps';
import { ORG_WORKSPACE_TOUR_STEPS } from 'components/MapPage/orgWorkspaceTour/orgWorkspaceTourSteps';
import { SITL_COP_TOUR_STEPS } from 'components/MapPage/sitlCopTour/sitlCopTourSteps';

export type FocTourAtomicRequirement = {
  requirementId: string;
  title: string;
};

type StepLike = {
  requirementId?: string;
  title: string;
};

function uniqueAtomicRequirements(
  steps: ReadonlyArray<StepLike>
): FocTourAtomicRequirement[] {
  const seen = new Set<string>();
  const out: FocTourAtomicRequirement[] = [];
  for (const step of steps) {
    const id = step.requirementId?.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push({ requirementId: id, title: step.title });
  }
  return out;
}

/** Tour label → unique atomic requirements (first step title wins per id). */
export const FOC_TOUR_ATOMIC_REQUIREMENTS: ReadonlyArray<{
  tourLabel: string;
  requirements: readonly FocTourAtomicRequirement[];
}> = [
  {
    tourLabel: FOC_TOUR_LABEL_ORG_WORKSPACE,
    requirements: uniqueAtomicRequirements(ORG_WORKSPACE_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING,
    requirements: uniqueAtomicRequirements(FOC_PLANNING_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_HUB_COP,
    requirements: uniqueAtomicRequirements(HUB_COP_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_SITL_COP,
    requirements: uniqueAtomicRequirements(SITL_COP_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_COP_LAYERS,
    requirements: uniqueAtomicRequirements(FOC_COP_LAYERS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_FSLTP,
    requirements: uniqueAtomicRequirements(FOC_FSLTP_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_NOTIFICATIONS,
    requirements: uniqueAtomicRequirements(FOC_NOTIFICATIONS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_INCIDENTS,
    requirements: uniqueAtomicRequirements(FOC_INCIDENTS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_INCIDENT_ROSTER,
    requirements: uniqueAtomicRequirements(FOC_INCIDENT_ROSTER_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_INITIAL_RESPONSE,
    requirements: uniqueAtomicRequirements(FOC_INITIAL_RESPONSE_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_TRANSITION,
    requirements: uniqueAtomicRequirements(FOC_TRANSITION_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_MODEL,
    requirements: uniqueAtomicRequirements(FOC_PLANNING_P_MODEL_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_MEETING,
    requirements: uniqueAtomicRequirements(FOC_PLANNING_P_MEETING_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
    requirements: uniqueAtomicRequirements(
      FOC_PLANNING_P_COMMAND_STAFF_TOUR_STEPS
    ),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
    requirements: uniqueAtomicRequirements(
      FOC_PLANNING_P_PREP_TACTICS_TOUR_STEPS
    ),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
    requirements: uniqueAtomicRequirements(
      FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_STEPS
    ),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
    requirements: uniqueAtomicRequirements(
      FOC_PLANNING_P_TACTICS_MEETING_TOUR_STEPS
    ),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
    requirements: uniqueAtomicRequirements(FOC_PLANNING_PREP_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_IAP_PREP_OPS,
    requirements: uniqueAtomicRequirements(FOC_IAP_PREP_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_IAP_FORMS,
    requirements: uniqueAtomicRequirements(FOC_IAP_FORMS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_WS,
    requirements: uniqueAtomicRequirements(FOC_WS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_CMD_IC,
    requirements: uniqueAtomicRequirements(FOC_CMD_IC_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_CMD_SAFETY,
    requirements: uniqueAtomicRequirements(FOC_CMD_SAFETY_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_CMD_LIAISON,
    requirements: uniqueAtomicRequirements(FOC_CMD_LIAISON_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_CMD_PIO,
    requirements: uniqueAtomicRequirements(FOC_CMD_PIO_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_CMD_LEGAL,
    requirements: uniqueAtomicRequirements(FOC_CMD_LEGAL_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLN_PSC,
    requirements: uniqueAtomicRequirements(FOC_PLN_PSC_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLN_SITL,
    requirements: uniqueAtomicRequirements(FOC_PLN_SITL_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLN_RESOURCE,
    requirements: uniqueAtomicRequirements(FOC_PLN_RESOURCE_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLN_DOCS,
    requirements: uniqueAtomicRequirements(FOC_PLN_DOCS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_PLN_DEMOB,
    requirements: uniqueAtomicRequirements(FOC_PLN_DEMOB_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_OPS,
    requirements: uniqueAtomicRequirements(FOC_OPS_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_LOG,
    requirements: uniqueAtomicRequirements(FOC_LOG_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_RES_MODEL,
    requirements: uniqueAtomicRequirements(FOC_RES_MODEL_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_RES_213RR,
    requirements: uniqueAtomicRequirements(FOC_RES_213RR_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_RES_211,
    requirements: uniqueAtomicRequirements(FOC_RES_211_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_RES_214,
    requirements: uniqueAtomicRequirements(FOC_RES_214_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_DMOB,
    requirements: uniqueAtomicRequirements(FOC_DMOB_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_EXT,
    requirements: uniqueAtomicRequirements(FOC_EXT_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_AI_IOC,
    requirements: uniqueAtomicRequirements(FOC_AI_IOC_TOUR_STEPS),
  },
  {
    tourLabel: FOC_TOUR_LABEL_AI_FOC,
    requirements: uniqueAtomicRequirements(FOC_AI_FOC_TOUR_STEPS),
  },
];

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function atomicRequirementsForTour(
  tourLabel: string
): readonly FocTourAtomicRequirement[] {
  return (
    FOC_TOUR_ATOMIC_REQUIREMENTS.find((entry) => entry.tourLabel === tourLabel)
      ?.requirements ?? []
  );
}

/**
 * TipTap task-list HTML for atomic requirements in a product tour.
 * Checked = Met, unchecked = Not met. Empty string when tour has none.
 */
export function buildFocTourRequirementTaskListHtml(
  tourLabel: string
): string {
  const requirements = atomicRequirementsForTour(tourLabel);
  if (requirements.length === 0) return '';

  const items = requirements.map((req) => {
    const label = escapeHtml(req.title);
    return `<li data-type="taskItem" data-checked="false"><label><input type="checkbox"><span></span></label><div><p>${label}</p></div></li>`;
  });

  return [
    '<p><strong>Requirement status</strong> (checked = Met, unchecked = Not met)</p>',
    `<ul data-type="taskList">${items.join('')}</ul>`,
  ].join('');
}
